import CustomIframeController from './controllers/custom-iframe-controller';
import customIFrameTemplateUrl from './views/custom-iframe.tpl.html';

angular
    .module('festzelt-os.modules.core')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.core', {
            abstract: true,
            url: '',
            template: '<ui-view/>'
        })
        .state('app.core.custom-iframe', {
            url: '/custom/{iframeAlias}',
            controller: CustomIframeController,
            controllerAs: 'vm',
            data: {
                hideBreadcrumb: true,
                fullWidth: true,
                right: 'core::custom-iframes'
            },
            templateUrl: customIFrameTemplateUrl,
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/core/routes.js